export const siteConfig = {
    title: "Brain Test — IQ-style Τεστ Λογικής",
    description: "Δοκίμασε την επίδοσή σου σε μοτίβα, λογική, ακολουθίες και χωρική αντίληψη με ένα premium IQ-style logic challenge.",
    headline: "Δοκίμασε τις δυνατότητές σου.",
    subheadline: "Απάντησε σε ερωτήσεις μοτίβων, λογικής, αριθμητικών ακολουθιών και χωρικής αντίληψης. Ολοκλήρωσε το test και δες την ενδεικτική σου επίδοση.",
    disclaimer: "Το Brain Test είναι IQ-style logic challenge. Η αναφορά επίδοσης παρουσιάζεται για προσωπική χρήση, κατανόηση του προφίλ απαντήσεων και σύγκριση προόδου.",
    footerLinks: [
        { label: "Όροι χρήσης", href: "/legal/terms" },
        { label: "Πολιτική απορρήτου", href: "/legal/privacy" },
        { label: "Πολιτική cookies", href: "/legal/cookies" },
        { label: "Πολιτική επιστροφών", href: "/legal/refund" },
        { label: "Επικοινωνία", href: "/contact" }
    ]
};
